
<div *ngIf="faqData && faqData.text">
    <span [innerHTML]="faqData.text"></span>
</div>

<div class="faq-wrapper">
    <app-faq-list></app-faq-list>
</div>






